import { Circle, East } from "@mui/icons-material";
import { Typography } from "@mui/material";
import React from "react";
import SummarySegmentDetail from "../../Summary Segment Detail/SummarySegmentDetail";

import classes from "./SelectedTrip.module.css";

export default function SelectedTrip({ airport, baggage, tripType }) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  function getDurationString(start, end) {
    const startTime = new Date(start);
    const endTime = new Date(end);
    let durationInMilisec = endTime - startTime;
    const durationHr = Math.floor(durationInMilisec / 3600000);
    durationInMilisec %= 3600000;
    const durationMin = durationInMilisec / 60000;
    return `${durationHr > 0 ? `${durationHr} h` : ""} ${durationMin} m`;
  }
  return (
    <div className={classes["selected-trip-container"]}>
      <div className={classes["selected-trip__header"]}>
        <Typography fontWeight={700}>
          {airport.segments[0].cityFrom || airport.segments[0].flyFrom}
          <East sx={{ margin: "0 0.5rem", fontSize: "1.5rem" }} />
          {airport.segments[airport.segments.length - 1].cityTo ||
            airport.segments[airport.segments.length - 1].flyTo}
        </Typography>
      </div>
      <div className={classes["selected-trip__flight-details"]}>
        <div className={classes["selected-trip__sub-header"]}>
          <div className={classes["selected-trip__sub-header-left"]}>
            {airport?.segments?.map((segment) => (
              <img
                width="40px"
                height="40px"
                src={`https://images.kiwi.com/airlines/64/${
                  segment.operating_carrier || segment.airline
                }.png`}
                alt="airline"
              />
            ))}
          </div>
          <Typography
            sx={{ "p.MuiTypography-root": { color: "#5a5a5a !important" } }}
          >
            {airport.segments[0].operating_carrier ||
              airport.segments[0].airline}{" "}
            {airport.segments[0].flight_no}
            <Circle
              sx={{
                width: "4px",
                height: "4px",
                fill: "#5a5a5a",
                margin: "0 0.5rem",
              }}
            />
            {airport.segments.length - 1} Stops
            <Circle
              sx={{
                width: "4px",
                height: "4px",
                fill: "#5a5a5a",
                margin: "0 0.5rem",
              }}
            />
            {getDurationString(
              airport.segments[airport.segments.length - 1].utc_departure,
              airport.segments[airport.segments.length - 1].utc_arrival
            )}
          </Typography>
          <div className={classes["selected-trip__sub-header-right"]}>
            <Typography>
              <b>{tripType}</b>{" "}
              {airport.segments[0].local_departure.split("T")[0].split("-")[2]}{" "}
              {months[
                new Date(airport.segments[0].local_departure).getMonth()
              ].substring(0, 3)}
            </Typography>
          </div>
        </div>
      </div>
      <div className={classes["selected-trip__segment-container"]}>
        {airport.segments.map((segment) => (
          <SummarySegmentDetail
            localStartTime={segment.local_departure}
            localEndTime={segment.local_arrival}
            startTime={segment.utc_departure}
            endTime={segment.utc_arrival}
            origin={segment.cityFrom || segment.flyFrom}
            destination={segment.cityTo || segment.flyTo}
            baggage={baggage}
          />
        ))}
      </div>
    </div>
  );
}
